// extracted by mini-css-extract-plugin
export var activeFilterButton = "_gt-c";
export var backButton = "_gt-4";
export var backIcon = "_gt-5";
export var chevronShortcut = "_gt-6";
export var container = "_gt-1";
export var editor = "_gt-8";
export var editorWrapper = "_gt-7";
export var prefix = "_gt-2";
export var searchIcon = "_gt-3";
export var suffix = "_gt-9";
export var suffixContent = "_gt-a";
export var suffixText = "_gt-b";
export var wrapper = "_gt-0";